import { css } from 'linaria';

export const ceilingsMountingTypeLayout = css`
  @media (--to-desktop) {
    margin-bottom: 0;
  }
`;

export const ceilingsMountingTypeText = css`
  margin-bottom: 32px;

  @media (--only-mobile) {
    margin-bottom: 24px;
  }
`;

export const ceilingsMountingTypeMoreInfo = css`
  margin-bottom: 32px;

  @media (--only-mobile) {
    margin-bottom: 48px;
  }
`;

export const hiddenCorniceTextContainer = css`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 735px;
  margin-bottom: 32px;
`;
